import { render, staticRenderFns } from "./NavBottom.vue?vue&type=template&id=11781738&"
import script from "./NavBottom.vue?vue&type=script&lang=js&"
export * from "./NavBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NavBottom.vue"
export default component.exports